import React from "react";

const CommercialDocProcedure = () => {
  return (
    <div className="birthCertProcedureContainer">
      <h2>
        Procedure for Commercial Documents <span>Attestation</span> in Bangalore{" "}
      </h2>
      <p>
        The attestation process for commercial documents in Bangalore involves
        several steps, each of which is critical to ensuring the authenticity
        and acceptance of the documents abroad. Goodway Attestation Services
        follows a systematic approach to streamline the process:
      </p>
      <ol>
        <li>
          1. <span> Notary Attestation:</span> The initial step in the
          attestation process is getting the document notarized. A notary public
          will verify the authenticity of the document and add their seal and
          signature.
        </li>
        <li>
          2. <span>Chamber of Commerce Attestation :</span> After notary
          attestation, the documents are submitted to the local Chamber of
          Commerce for further verification. This step is crucial for
          business-related documents as it confirms the legitimacy of the
          business operations.
        </li>
        <li>
          3. <span> State Government Attestation:</span> The next step involves
          attestation by the relevant state government department. This step
          ensures that the documents comply with state regulations and are
          recognized at the national level.
        </li>
        <li>
          4. <span>MEA (Ministry of External Affairs) Attestation:</span> Once
          the Home Department attestation is complete, the document must be
          attested by the Ministry of External Affairs. This attestation
          confirms that the document is genuine and can be used internationally.
        </li>
        <li>
          5. <span>Embassy Attestation:</span>The Ministry of External Affairs
          attestation is a critical step in the process. The MEA verifies the
          documents and adds its official seal and signature, confirming their
          authenticity for international use.
        </li>
      </ol>
      <p>
        During each step of this process, seals and signatures are added to the
        documents as they are verified. Birth certificate attestation in
        Bangalore thus involves a thorough and detailed verification process to
        ensure the document’s authenticity.
      </p>
    </div>
  );
};

export default CommercialDocProcedure;
